import React from "react"

import { AuthProvider } from "./context/authContext"
import { FirestoreProvider } from "./context/firestoreContext"

interface Props {
  element: React.ReactNode
}

const CombinedProvider = ({ element }: Props) => {
  return (
    <AuthProvider>
      <FirestoreProvider>{element}</FirestoreProvider>
    </AuthProvider>
  )
}

export default CombinedProvider
